import React from "react";
import "./App.css";

// Data
import countryData from "./data/countryData.json";
import countryRegSubreg from "./data/countryRegSubreg.json";
import organizationData from "./data/organizationData.json";
import stepContents from "./data/stepContents.json";
import recordMatrix from "./data/recordMatrix.json";
import recordMatrixTop3 from "./data/recordMatrixTop3.json";

// External
import { useImmer } from "use-immer";

// Local
import {
  Container,
  VerticalSpacing,
  EntryPicture,
  ExitPicture,
  Earth,
  WideEllipseTop,
  WideEllipseBottom,
  LightSkies,
  LightSkiesBackdrop,
  DarkSpace
} from "./styled/styled";
import { useScrollBounds } from "./lib/useScrollBounds";
import { setCluster } from "./lib/helper";
import Title from "./container/Title";
import Dataviz from "./container/Dataviz";
import Intro from "./container/Intro";
import Outro from "./container/Outro";
import Stars from "./assets/svg/Stars";
import Planes from "./assets/svg/Planes";
import Clouds from "./assets/svg/Clouds";
import Rockets from "./assets/svg/Rockets";
import Moon from "./assets/svg/Moon";

const initialState = (function() {
  const currentData = countryData;
  const currentStepValue = 0;
  const currentStep = stepContents[currentStepValue];
  const currentOrgs = currentStep.organizations;
  const currentProjection = "geo";
  const tooltip = {
    country: null,
    membershipCount: null,
    x: null,
    y: null,
    mutualCountries: []
  };
  const organization = {
    hovered: false,
    orgName: null,
    orgCode: null,
    allMembers: [],
    primaryMembers: [],
    secondaryMembers: [],
    toggle: false
  };
  const cluster = null;
  const projection = false;

  return {
    currentData,
    currentStepValue,
    currentStep,
    currentOrgs,
    currentProjection,
    tooltip,
    organization,
    cluster,
    projection
  };
})();

function App() {
  const [state, updateState] = useImmer(initialState);
  const data = {
    countryData,
    countryRegSubreg,
    organizationData,
    stepContents,
    recordMatrix,
    recordMatrixTop3
  };
  const [
    darkSpaceRef,
    { containerHeight, containerWidth, windowWidth, windowHeight }
  ] = useScrollBounds();

  const actions = {
    onStepEnter: ({ element, data, direction }) => {
      updateState(state => {
        state.currentStepValue = data;
        state.cluster = setCluster(data);
      });
    },
    hoverCountry: (ctry, memCount, x, y) => {
      updateState(state => {
        state.tooltip.hovered = !!ctry;
        state.tooltip.country = ctry;
        state.tooltip.membershipCount = memCount;
        state.tooltip.x = x;
        state.tooltip.y = y;
        state.tooltip.mutualCountries = recordMatrixTop3.filter(
          muCtry => muCtry.country1 === ctry
        );
      });
    },
    hoverOrganization: orgCode => {
      updateState(state => {
        const currOrg = organizationData.find(
          org => org.organizationCode === orgCode
        );
        state.organization.orgCode = orgCode;
        state.organization.orgName =
          typeof currOrg === "undefined" ? orgCode : currOrg.organization;

        state.organization.allMembers = organizationData
          .filter(org => org.organization === state.organization.orgName)
          .map(org => {
            return {
              countryName: org.countryName,
              countryCode: org.countryCode
            };
          });

        state.organization.primaryMembers = organizationData
          .filter(org => org.organization === state.organization.orgName)
          .filter(org => org.membershipCategory === "primary")
          .map(org => {
            return {
              countryName: org.countryName,
              countryCode: org.countryCode
            };
          });

        state.organization.secondaryMembers = organizationData
          .filter(org => org.organization === state.organization.orgName)
          .filter(org => org.membershipCategory === "secondary")
          .map(org => {
            return {
              countryName: org.countryName,
              countryCode: org.countryCode
            };
          });

        state.organization.hovered = true;
      });
    },
    unhoverOrganization: () => {
      updateState(state => {
        state.organization.hovered = false;
        state.organization.orgCode = null;
        state.organization.orgName = null;
        state.organization.allMembers = [];
        state.organization.primaryMembers = [];
        state.organization.secondaryMembers = [];
      });
    },
    // clickOrganization: org => {
    //   updateState(state => {
    //     state.organization.selected = org;
    //     // state.organization.toggle = !toggle;
    //   });
    // },
    switchProjection: proj => {
      updateState(state => {
        state.currentProjection = proj;
      });
    },
    toggleProjection: () => {
      updateState(state => {
        state.currentProjection = !(state.currentProjection === "geo")
          ? "geo"
          : "tsne";
        state.projection = !(state.projection === "geo");
      });
    }
  };

  return (
    <div>
      <LightSkies>
        <VerticalSpacing />
        <Title />
        <VerticalSpacing style={{ height: "24px" }} />
        <Container>
          <Intro />
        </Container>
        <VerticalSpacing style={{ marginBottom: "-50vh" }} />
        <Planes />
        <EntryPicture>
          <Clouds />
          <Clouds />
          <Clouds />
        </EntryPicture>
        <WideEllipseTop className="earth ellipseBottom" />
        {/* <WideEllipse orientation="top" /> */}
      </LightSkies>
      <LightSkiesBackdrop />
      <Earth>
        <Dataviz state={state} actions={actions} data={data} />
      </Earth>
      <DarkSpace ref={darkSpaceRef}>
        <WideEllipseBottom className="earth ellipseBottom" />
        <VerticalSpacing />
        <Container>
          <Outro />
        </Container>
        {/* <VerticalSpacing />
        <VerticalSpacing />
        <VerticalSpacing /> */}
        <ExitPicture />
        <Rockets />
      </DarkSpace>
      <Moon />
      <Stars
        dim={{ containerHeight, containerWidth, windowWidth, windowHeight }}
      />
    </div>
  );
}

export default App;
